import { v1 as uuid1 } from 'uuid';
import { createActions } from 'redux-actions';

const actions = createActions(
  {
    PUSH: (title, message, type, key) => ({ snackBarMessage: {
      key: key || uuid1(),
      title,
      message,
      type,
    } }),
    REMOVE: (key) => ({ key }),
    CLEAR: () => ({}),
  },
  { prefix: 'CORE/SNACKBAR' },
);

export const {
  push,
  clear,
  remove,
} = actions;
